import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import ConfirmationModal from '../common/ConfirmationModal/ConfirmationModal';
import { useLanguage } from '../../utils/language';

const AssignmentModal = ({ toggleModal, assignmentMutation, loading }) => {
  const { t } = useTranslation();
  const { langCode } = useLanguage();
  return (
    <div data-testid="confirmation-modal">
      <ConfirmationModal
        lang={langCode}
        loading={loading}
        onClose={toggleModal}
        onConfirm={() => {
          assignmentMutation('PUBLISHED');
        }}
        title={t('Confirm')}
      >
        <span>
          {t(
            'Are you sure you want to publish and display the assignment to your students?',
          )}
        </span>
      </ConfirmationModal>
    </div>
  );
};

AssignmentModal.defaultProps = {
  loading: false,
};

AssignmentModal.propTypes = {
  toggleModal: PropTypes.func.isRequired,
  assignmentMutation: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

export default AssignmentModal;
